import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100dvh;
  overflow: hidden;

  iframe {
    width: inherit;
    height: inherit;
  }
`